<template>
	<div :class="darkMode ? 'dark' : ''">

      <!-- Messaggio che appare se si accede da mobile e schermi md -->
		<div id="onlydesktop" class="block md:!hidden"> 
			<div v-if="loggedAs && loggedAs.ruolo=='admin'" id="onlydesktopAdmin" class=" bg-csenRed-200 p-12">
				<div class="bg-csenRed-100 text-csenRed-600 p-3 inline-flex rounded-full mb-4">
					<MobileIcon></MobileIcon>
				</div>
				<div class="bg-csenGreen-100 text-csenGreen-600 p-3 inline-flex rounded-full mb-4">
					<DesktopIcon></DesktopIcon>
				</div>
				<div><h2 class="text-left text-lg text-csenRed-800 font-bold mb-2">⛔ Accesso non consentito</h2></div>
				<p class=" text-left text-csenRed-900 text-base font-semibold">L'accesso come amministratore <strong>non è consentito da mobile</strong>. Collegati da un computer desktop per svolgere le attività come amministratore.</p> 

			</div>
		</div>

      <div id="maincontainer" class="hidden md:!block sm:px-[5%] !font-sans bg-white dark:bg-[#171a35]">
         
         
         <div class="bg-csenBlue-950 dark:bg-csenBlue-900 px-12 sm:px-24 py-12 rounded-b-md">
			 <!-- MENU TECNICI -->
			<div>
				<MenuTecnici @avvia-guida="avviaTour"></MenuTecnici>
			</div>
      
         
         <!-- INIZIO RICERCA -->
           <div flat class="mt-6 bg-white px-6 py-3 rounded-md">
              <v-text-field
                 v-model="search"
                 hide-details
                 flat 
                 light
                 solo
                 class="relative w-full border-none rounded-lg "
                 prepend-icon="mdi-magnify"
                 clearable
                 placeholder="Cerca referente"
                 clear-icon="mdi-close-circle-outline"
                 @click:clear="search = null"
                 ></v-text-field>
           </div>
           <!-- FINE RICERCA -->
        </div>
        <div class="flex justify-end mt-3 mb-0 py-2 rounded-md gap-x-2">
           <v-btn id="aggiungi-referente" @click="openReferenteDialog()" class="!bg-csenBlue-900 dark:!bg-csenBlue-700 !text-white !tracking-normal !py-6">
              <PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
              <span>Nuovo referente</span>
           </v-btn>
        </div>
        <div id="tabella" class="py-3">
           <v-data-table id="tabella-referenti" class="tabella-csen" :headers="headers" :items="referenti" :loading="isLoading" :search="search" :footer-props="{itemsPerPageText: 'Referenti per pagina'}">
            
            <template v-slot:item.nome="{ item }">
                 <span class="font-medium uppercase"> {{ item.nome }} </span>
              </template>
            
            
            <template v-slot:item.autogestisce_rinnovi="{ item }">
                 <span class="!font-bold flex justify-start" v-if="item.autogestisce_rinnovi == 1"><BadgeSi></BadgeSi></span>
                 <span class="!font-bold flex justify-start" v-else><BadgeNo></BadgeNo></span>
              </template>
              <template v-slot:item.azioni="{ item }">
                 <div class="d-flex justify-end gap-1">
                    <!-- <v-btn class="!bg-violet-100 !text-violet-600 !tracking-normal !px-3" @click="openDialogEdizioni = true">
                       <HistoryIcon class="!h-5 !w-5"></HistoryIcon>
                       <span class="ml-2">Edizioni</span>
                       </v-btn>   -->
                    <button id="modifica-referente" type="button" class="bg-csenOrange-100 !text-csenOrange-500 dark:bg-csenOrange-500 dark:!text-white hover:dark:!brightness-125 inline-flex justify-center content-center px-auto rounded-md hover:bg-csenOrange-500 hover:!text-white transition w-9 h-9" title="Modifica Referente" @click="openReferenteDialog(item)">
                       <EditIcon class="my-auto"></EditIcon>
                    </button>
                    <button id="elimina-referente" type="button" class="bg-red-100 dark:bg-csenRed-500 !text-csenRed-500 dark:!text-white inline-flex hover:dark:!brightness-125 justify-center content-center px-auto rounded-md hover:bg-csenRed-500 hover:!text-white transition w-9 h-9" title="Elimina Referente" @click="eliminaReferente(item.id)">
                       <DeleteIcon class="my-auto"></DeleteIcon>
                    </button>
                 </div>
              </template>
           </v-data-table>
        </div>

		<!-- LOGOUT -->
		<div class="block sm:flex gap-2 !justify-start border-t border-t-gray-300 dark:border-t-csenBlue-300 pt-4 mt-3">
		  <template>
			 <v-btn v-if="loggedAs && loggedAs.ruolo && loggedAs.ruolo.length > 0" class=" !block !mb-2 sm:!inline sm:!mb-0 !tracking-normal !bg-slate-200 !text-slate-600 dark:!text-white dark:!bg-csenBlue-800" @click="logout">
				<v-icon left>mdi-logout</v-icon>
				Logout
			 </v-btn>
		  </template>
	   </div>

		  <!-- TO TOP -->
        <div 
               class="flex fixed justify-end items-end bottom-6 md:bottom-5 right-6 md:right-5 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition" 
               @click="scrollToTop"
			   title="Torna in cima"
            ><div><ChevronUpIcon></ChevronUpIcon></div>
            </div>

	   <!-- FOOTER -->
	   <div> 
		   <FooterComponent></FooterComponent>
	   </div>
	   <!-- FINE FOOTER -->


     </div>

     
     <!-- DIALOG REFERENTE -->
     <template>
        <v-dialog v-model="isReferenteDialogOpen" width="600px" persistent>
           <v-card plain class="dark:!bg-csenBlue-800 font-sans">
              <v-card-title class="font-bold text-2xl py-6 pl-8">
                 <span class="flex-grow">
                    <h2>
                       Aggiungi / Modifica referente
                    </h2>
                 </span>
                 <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeReferenteDialog()">
                    <CloseIcon />
                 </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="!m-0 !p-0">
                 <div class="my-5 mx-8">
                    <div>
                        <p class="text-sm font-semibold mt-4 mb-3 tracking-wide !text-gray-800 dark:!text-csenBlue-200">Nome del referente</p>
                        <v-text-field
                           v-model="referenteInModifica.nome"
                           label="Nome"
                           outlined
                           @input="referenteModificato = true"
                        ></v-text-field>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <div>
                           <p class="text-sm font-semibold mt-4 mb-3 tracking-wide !text-gray-800 dark:!text-csenBlue-200"> Gestione autonoma dei rinnovi</p>
                        </div>
                        <v-switch
                           v-model="referenteInModifica.autogestisce_rinnovi"
                           color="primary"
                           @change="referenteModificato = true"
                        ></v-switch>
                    </div>
                 </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="p-4 justify-end bg-white dark:bg-csenBlue-800">
                 <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeReferenteDialog()">Annulla</v-btn>
                 <v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5" text @click="aggiungiModificaReferente()">Salva modifiche</v-btn>
              </v-card-actions>
           </v-card>
        </v-dialog>
     </template>

     <v-tour name="myTourReferenti" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>

     <!-- Overlay per bloccare i click durante il tour -->
     <div v-if="tourAvviato" class="tour-overlay"></div>
  </div>
</template>
<script>
  import EditIcon from '../components/icons/EditIcon.vue';
  import DeleteIcon from '../components/icons/DeleteIcon.vue';
  import CloseIcon from '../components/icons/CloseIcon.vue';
  import HistoryIcon from '../components/icons/HistoryIcon.vue';
  import MenuTecnici from '../components/MenuTecnici.vue';
  import BadgeNo from '../components/BadgeNo.vue';
  import BadgeSi from '../components/BadgeSi.vue';

  import mixin, { methods } from '../mixin';
  import store from '../store';
  
  export default {
    components: {
      MenuTecnici, EditIcon, DeleteIcon, HistoryIcon, CloseIcon,
    },
    mixins: [mixin],
     data() {
      return {
        isLoading: false,
        referenti: [],
        search: null,
        isReferenteDialogOpen: false,
        referenteInModifica: {
            id: null,
            nome: null,
            autogestisce_rinnovi: false,
        },
        headers: [
          {text: 'Referente', value: 'nome'},
          {text: 'Numero di Tecnici', value: 'tecnici_count'},
          {text: 'Gestione autonoma dei rinnovi', value: 'autogestisce_rinnovi'},
          {text: 'Azioni', value: 'azioni', sortable:false, class: 'text-end'},
        ],

        referenteModificato: false,

         tourAvviato: false,
         tourCallbacks: {
            onFinish: this.fineTour,
            onSkip: this.fineTour,
            onStop: this.fineTour,
         },
         tourSteps: [
            {
               target: '#menu-referenti-tab',
               content: `
                  Benvenuto nella pagina dedicata ai Referenti!
               `,
            },
            {
               target: '#tabella-referenti',
               content: `
                  Qui puoi vedere la tabella con l'elenco completo di tutti i referenti già inseriti, con i dettagli di ciascuno riportati in ogni riga.<br/><br/>
                  Puoi individuare un referente scorrendo nella tabella oppure utilizzando la barra di ricerca situata in alto dove leggi “Cerca referente”.
               `,
            },
            {
               target: '#modifica-referente',
               content: `
                  Per modificare un referente, clicca su questa matita.
               `,
            },
            {
               target: '#elimina-referente',
               content: `
                  Se vuoi invece eliminarlo, fai clic sull'icona del cestino.
               `,
            },
            {
               target: '#aggiungi-referente',
               content: `
                  Se desideri aggiungere un nuovo referente basta cliccare su questo pulsante.<br/><br/>
                  La guida di questa sezione è finita.<br/>
                  Per continuare la guida vai nelle altre pagine del menu.<br/><br/>
                  Saluti sportivi!
               `,
            }
         ]
      }
   },
   created() {
      this.getReferenti();
   },
   mounted(){
      if(!this.isGuidaCompleta('is_guida_referenti_completa')){
			this.tourAvviato = true;
         this.$tours['myTourReferenti'].start();
         this.setGuidaCompleta('is_guida_referenti_completa');
      }
   },
   methods: {
      avviaTour(){
			this.tourAvviato = true;
			this.$tours['myTourReferenti'].start();
		},
		fineTour(){
			this.tourAvviato = false;
		},
      getReferenti(){
        this.isLoading = true;
        axios.get('/referenti_con_tecnici')
          .then(response => {
            if(response.status == 200){
              this.referenti = response.data;
            } else {
              console.log("Impossibile caricare i referenti!");
            }
          })
          .catch(error => {
            console.error('Errore nel recupero dei referenti:', error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      resetReferenteInModifica(){
         this.referenteInModifica.id = null;
         this.referenteInModifica.nome = null;
         this.referenteInModifica.autogestisce_rinnovi = false;

         this.referenteModificato = false;
      }, 
      openReferenteDialog(referente) {
         if(referente){
            this.referenteInModifica.id = referente.id
            this.referenteInModifica.nome = referente.nome
            this.referenteInModifica.autogestisce_rinnovi = referente.autogestisce_rinnovi
         } else {
            this.closeReferenteDialog(false);
         }

         this.isReferenteDialogOpen = true; 
      },
      closeReferenteDialog(daConfermare = true){
         if(this.referenteModificato && daConfermare){
            store.commit('mostraDialogConferma', 
               {
                  titolo: 'Esci senza salvare le modifiche',
                  testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
                  onConferma:()=>{
                     this.resetReferenteInModifica();
                     this.isReferenteDialogOpen = false;
                     store.commit('nascondiDialogConferma');
                  }, 
                  onAnnulla:()=>{
                     store.commit('nascondiDialogConferma');
                  }
               }
            )
         } else {
            this.resetReferenteInModifica();
            this.isReferenteDialogOpen = false;
         }
      },
      aggiungiModificaReferente(){
         if(this.referenteInModifica.id == null){
            axios.post('/referenti', this.referenteInModifica)
               .then(response => {
                  this.closeReferenteDialog(false);
                  this.getReferenti();

                  store.commit('mostraSnack', {messaggio: 'Referente inserito con successo', tipo: 'success'})
               })
               .catch(error => {
                  console.error('Errore nel salvataggio del nuovo referente:', error);
               })
               .finally(() => {
               });
         } else {
            axios.patch(`/referenti/${this.referenteInModifica.id}`, this.referenteInModifica)
               .then(response => {
                  this.closeReferenteDialog(false);
                  this.getReferenti();

                  store.commit('mostraSnack', {messaggio: 'Referente modificato con successo', tipo: 'success'})
               })
               .catch(error => {
                  console.error('Errore nella modifica del referente:', error);
               })
               .finally(() => {
               });
         }
      },
      eliminaReferente(id){
         store.commit('mostraDialogConferma', 
					{
						titolo: 'Elimina referente', 
						testo:`Sicuro di voler eliminare questo referente?`,
						onConferma:()=>{
							axios.delete(`/referenti/${id}`)
                        .then(response => {
                           this.getReferenti();
                           store.commit('mostraSnack', {messaggio: 'Referente eliminato con successo', tipo: 'success'})
                        })
							store.commit('nascondiDialogConferma')
						}, 
						onAnnulla:()=>{
							store.commit('nascondiDialogConferma')
						}
					}
				)
      },
  }
  }
        
</script>
<style lang="scss" scoped>

.tabella-csen {
   background-color: #fff; 
   ::v-deep .v-data-table__wrapper th {
      color: #27316e !important;
      font-size:15px !important;
      background-color: #eef5ff;
      padding: 1rem;
   }
};

.dark {
   ::v-deep .v-data-table__wrapper th {
      color: #c7dcfe !important;
      font-size:15px !important;
      padding: 1rem;
   }
};

</style>
